var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-container',{attrs:{"icon":"student","title":_vm.$t('student portal'),"configurable":true,"configure_modal":_vm.configure_modal}},[_c('users')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }